'use client';

import { useSession } from 'hooks/useSession';
import { BaseModalRenderer } from 'store/modal-store';

/**
 * Thin wrapper around the modal-store's `BaseModalRenderer` that injects the
 * session's `isLoggedIn` state. The renderer uses this to gate the URL-
 * deep-link auto-open logic so modals don't open before Stytch initializes.
 */
export default function ModalRenderer() {
  const { isLoggedIn } = useSession();
  return <BaseModalRenderer isLoggedIn={isLoggedIn} />;
}
